import { defineComponent as _defineComponent } from 'vue'
import { type Colors } from '../../../types';
import { CategoryCard } from '../';
import { AbSection, AbContainer, AbLink } from '../../ui';
import { Spacing } from '../../../helpers/shared-props';

interface Props {
  categories: {
    link: string;
    image?: string;
    alt?: string;
    title?: string;
    subtitle?: number | string;
    variant?: Colors;
    size?: 'small' | 'big';
  }[];
  spacing?: Spacing;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CardSectionCategories',
  props: {
    categories: null,
    spacing: null
  },
  setup(__props: any) {



return { __sfc: true,CategoryCard, AbSection, AbContainer, AbLink }
}

})